<template>
    <card>
        <card-header>
            <card-title>
                <translate>aktive Angebote</translate>
            </card-title>
        </card-header>
        <card-content>
            <table class="table table--stripped table--td-top table--lot">
                <thead>
                <tr>
                    <th>
                        <translate>PF-Nr</translate>
                    </th>
                    <th>
                        <translate>Projekttitel</translate>
                    </th>
                    <th class="text-center">
                        <translate>Zeichnung</translate>
                    </th>
                    <th class="text-right">
                        <translate>Stück</translate>
                    </th>
                    <th class="text-right">
                        <translate>Stückpreis</translate>
                    </th>
                    <th class="text-right">
                        <translate>Nettopreis</translate>
                    </th>
                    <th class="text-right">
                        <translate>Lieferzeit</translate>
                    </th>
                    <th class="text-right">
                        <translate>gültig bis</translate>
                    </th>
                    <th class="text-center">
                        <translate>Warenkorb</translate>
                    </th>
                    <th class="text-right">
                        <translate>Angebote<span>alternative</span></translate>
                    </th>
                    <th class="text-center">
                        <translate>ablehnen<span>endgültig</span></translate>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="offer in offers" :key="offer.index">
                    <td>
                        {{ offer.pfnumber }}
                    </td>
                    <td>{{ offer.project_name }}</td>
                    <td class="text-center">
                        <a href="#" class="btn btn--dense btn--icon-inline">
                            <svg-vue icon="document-file-download" class="icon"/>
                        </a>
                    </td>
                    <td class="text-right lot-cell" v-html="offer.lot_qty"></td>
                    <td class="text-right lot-cell" v-html="offer.price_per_unit"></td>
                    <td class="text-right lot-cell" v-html="offer.net_price"></td>
                    <td class="text-right lot-cell" v-html="offer.lot_delivery_days"></td>
                    <td class="text-right">{{ offer.offer_valid_date }}</td>

                    <td class="text-center lot-cell">
                        <a href="#" class="btn btn--secondary btn--dense btn--icon-inline">
                            <svg-vue icon="shopping-cart" class="icon"/>
                        </a>
                    </td>
                    <td class="text-right">
                        {{ offer.bid_round_member_offers_count_string }}
                    </td>
                    <td class="text-center">
                        <a href="#" class="btn btn--error btn--dense btn--icon-inline">
                            <svg-vue icon="delete-disabled" class="icon"/>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import CardHeader from '@partfactory/Shared/Card/CardHeader';

export default {
    name: 'DashboardDummy',
    components: {CardHeader, CardTitle, CardContent, Card},

    data() {
        const offers = [
            {'pfnumber': 'PF 100', 'project_name': 'Projekt 1', 'lot_qty': '10', 'price_per_unit': '1,50 €', 'net_price': '100,00 €', 'lot_delivery_days': '10 Tage', 'offer_valid_date': '20.06.2023', 'bid_round_member_offers_count_string': '15' },
            {'pfnumber': 'PF 101', 'project_name': 'Projekt 2', 'lot_qty': '10', 'price_per_unit': '1,50 €', 'net_price': '100,00 €', 'lot_delivery_days': '10 Tage', 'offer_valid_date': '20.06.2023', 'bid_round_member_offers_count_string': '15' },
            {'pfnumber': 'PF 102', 'project_name': 'Projekt 3', 'lot_qty': '10', 'price_per_unit': '1,50 €', 'net_price': '100,00 €', 'lot_delivery_days': '10 Tage', 'offer_valid_date': '20.06.2023', 'bid_round_member_offers_count_string': '15' },
            {'pfnumber': 'PF 103', 'project_name': 'Projekt 4', 'lot_qty': '10', 'price_per_unit': '1,50 €', 'net_price': '100,00 €', 'lot_delivery_days': '10 Tage', 'offer_valid_date': '20.06.2023', 'bid_round_member_offers_count_string': '15' },
            {'pfnumber': 'PF 104', 'project_name': 'Projekt 5', 'lot_qty': '10', 'price_per_unit': '1,50 €', 'net_price': '100,00 €', 'lot_delivery_days': '10 Tage', 'offer_valid_date': '20.06.2023', 'bid_round_member_offers_count_string': '15' },
            {'pfnumber': 'PF 105', 'project_name': 'Projekt 6', 'lot_qty': '10', 'price_per_unit': '1,50 €', 'net_price': '100,00 €', 'lot_delivery_days': '10 Tage', 'offer_valid_date': '20.06.2023', 'bid_round_member_offers_count_string': '15' },
        ];

        return {offers};
    }

};
</script>
